import { render } from "./ActiveUploadCard.vue?vue&type=template&id=70848a73&scoped=true"
import script from "./ActiveUploadCard.vue?vue&type=script&lang=js"
export * from "./ActiveUploadCard.vue?vue&type=script&lang=js"

import "./ActiveUploadCard.vue?vue&type=style&index=0&id=70848a73&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70848a73"]])

export default __exports__